class EluxaStickyBar extends HTMLElement {
  constructor() {
    super();
    this.buyButton = this.querySelector('.eluxa-sticky-bar__buy');
    this.priceEl = this.querySelector('.eluxa-sticky-bar__price');
    this.buyButton?.addEventListener('click', this.onBuyNow.bind(this));
    this.observeHero();
    this.subscribeToVariantChange();
  }

  observeHero() {
    const heroEl = document.querySelector('product-info');
    if (!heroEl || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('show', entry.boundingClientRect.bottom < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(heroEl);
  }

  subscribeToVariantChange() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event?.data?.variant;
      if (!variant || !this.buyButton) return;

      this.buyButton.dataset.variantId = variant.id;
      this.buyButton.toggleAttribute('disabled', !variant.available);

      const priceSource = document.getElementById(`price-${event.data.sectionId}`);
      const priceText = priceSource?.querySelector('.price-item--regular, .price-item--sale')?.textContent;
      if (priceText && this.priceEl) this.priceEl.textContent = priceText.trim();
    });
  }

  onBuyNow(event) {
    event.preventDefault();
    if (!this.buyButton || this.buyButton.hasAttribute('disabled')) return;

    // Razorpay Magic Checkout: press the product page's own Razorpay "Buy Now" button so the shopper goes through
    // Magic Checkout (it adds the selected variant and opens its checkout). Going to /checkout would open the old
    // Shopify checkout instead.
    const magicButton =
      document.querySelector('product-info magic-checkout-btn') || document.querySelector('magic-checkout-btn');
    if (magicButton) {
      magicButton.click();
      return;
    }

    // Fallback when Razorpay is not on the page: add to cart and use the regular checkout.
    const variantId = this.buyButton.dataset.variantId;
    if (!variantId) return;

    const addUrl = this.dataset.cartAddUrl || window.routes?.cart_add_url || '/cart/add.js';
    this.buyButton.setAttribute('disabled', 'disabled');

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Add to cart failed');
        window.location.href = '/checkout';
      })
      .catch(() => {
        this.buyButton.removeAttribute('disabled');
      });
  }
}

customElements.define('eluxa-sticky-bar', EluxaStickyBar);
